var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"infos"},[_c('div',{staticClass:"devices"},[_vm._v("设备数:"+_vm._s(_vm.deviceNum)+" ")]),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":_vm.toLayer}},[_vm._v("前往管理")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }